<template>
  <div>
    <el-dialog title="设置选修课" :visible.sync="show" width="450px">
      <el-form :model="data">
        <el-form-item label="选修课" label-width="75px" prop="SubjectIds">
          <el-select v-model="data.SubjectIds" size="mini" filterable multiple style="width: 100%;">
            <el-option
              v-for="(i,key) in Subjects"
              :key="key"
              :label="i.Subject"
              :value="i.SubjectId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="save">保 存</el-button>
        <el-button size="mini" @click="close">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      api: require("@/api/st/studentclass").default,
      subject_api: require("@/api/ed/subject").default,
      data: {
        TermId: 0,
        StudentIds: [],
        SubjectIds: [],
      },
      Subjects: [],
      show: false,
      // rules: {
      //   SubjectIds: [{ required: true, message: "请选择选修课" }],
      // },
    };
  },
  methods: {
    open(data) {
      console.log("data", data);
      this.data.TermId = data.TermId;
      this.data.StudentIds = data.StudentIds;
      this.subject_api.list({}).then((res) => {
        if (res.Code == 0) this.Subjects = res.Data;
      });
      this.show = true;
    },
    close() {
      this.Subjects = [];
      this.data.SubjectIds = [];
      this.data.StudentIds = [];
      this.show = false;
    },
    save() {
      this.api.setCourse(this.data).then((res) => {
        if (res.Code == 0) {
          this.$emit("set-elective", this.SeatNumber);
          this.show = false;
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>

<style>
</style>